import { Menu } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api";

export default function CustomerHeader({ onCategorySelect, isMobile = false }) {
  const [categories, setCategories] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const location = useLocation();
  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    if (
      !location.pathname.includes("subcategories") &&
      !location.pathname.includes("product-list")
    ) {
      setSelectedKey(null);
    }
  }, [location.pathname]);

  const loadCategories = async () => {
    const res = await api.get("/categories");
    setCategories(res.data || []);
  };

  const menuItems = categories.map((cat) => ({
    key: `cat-${cat.id}`,
    label: cat.name,
  }));

  const handleClick = (e) => {
    setSelectedKey(e.key);

    if (e.key.startsWith("cat-")) {
      const id = Number(e.key.replace("cat-", ""));

      const category = categories.find((c) => c.id === id);

      onCategorySelect({
        type: "subcategory",
        id,
      });
    }
  };

  return isMobile ? (
    <Menu
      mode="inline"
      theme="dark"
      items={menuItems}
      onClick={handleClick}
      selectedKeys={selectedKey ? [selectedKey] : []}
    />
  ) : (
    <div
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        borderBottom: "1px solid #eee",
        background: !isMobile ? "#fff" : "",
        width: "100%",
        position: "sticky",
        top: 64,
        zIndex: 9,
      }}
    >
      <Menu
        mode="horizontal"
        theme="light"
        items={menuItems}
        onClick={handleClick}
        selectedKeys={selectedKey ? [selectedKey] : []}
        style={{
          display: "inline-flex",
          minWidth: "max-content",
          gap: 8,
        }}
      />
    </div>
  );
}
